import angular from 'angular';
import {
  loaderService,
  reportsDataService
} from 'app/services';
import { alerts } from 'app/components/global';

import directive from './report-type.directive';
import controller from './report-type.controller';

import reportInstances from './reportInstances';
import bulkDeleteArchivedReportInstancesDialog from './dialog.bulkDeleteArchivedReportInstancesDialog';
import bulkDeleteArchivedReportInstancesConfirmDialog from './dialog.bulkDeleteArchivedReportInstancesConfirmDialog';

export default angular.module('app.components.reports.archivedReports.reportType', [
  loaderService,
  reportsDataService,
  alerts,
  reportInstances,
  bulkDeleteArchivedReportInstancesDialog,
  bulkDeleteArchivedReportInstancesConfirmDialog
])
  .directive('archivedReportType', directive)
  .controller('ArchivedReportTypeController', controller)
  .name;

console.log('app.components.reports.archivedReports.reportType created');
